let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5hFEw"), load("bCgoB"), load("MrUJ0"), load("3Zr7p"), load("3Eu7W"), load("dH2J7"), load("2YlyO")]).then(() => parcelRequire('753aK'));